import axiosInstance from "../axiosInterceptor";

export async function getSubcategoryWiseContent(subcategoryId) {
  const response = await axiosInstance.get(
    `/admin/subcategory/getSubcategoryWiseContent/${subcategoryId}`
  );
  const data = response?.data;
  return data;
}
